<p-dialog
  header="Pricing Parameters"
  [modal]="true"
  [visible]="true"
  [focusOnShow]="false"
  [style]="{ width: '42rem', maxWidth: '95vw' }"
  appendTo="body"
  (onHide)="closed.emit()"
>
  <div class="flex flex-col gap-5">
    <div>
      <div class="text-sm font-semibold text-surface-switch-900">
        {{ pricingModel?.name }}
      </div>
      <div class="text-sm text-muted-color">
        Review model defaults and set per-CAD overrides before adding the item.
      </div>
    </div>

    @if (!hasParameters) {
      <div
        class="rounded border border-surface-switch-200 bg-surface-switch-50 p-4 text-sm text-muted-color"
      >
        This pricing model does not expose configurable parameters.
      </div>
    } @else if (cadParameterGroups.length === 0) {
      <div
        class="rounded border border-surface-switch-200 bg-surface-switch-50 p-4 text-sm text-muted-color"
      >
        No CAD or drawing is linked to this item or an ancestor yet. The model
        parameters are shown below; link CAD or a drawing PDF to this item or a
        parent item to set per-geometry overrides.
      </div>

      <div class="pointer-events-none opacity-60">
        <app-parameter-editor
          [parameterSchemas]="parameterSchemas"
          [values]="{}"
          idPrefix="add-item-nocad-"
        />
      </div>
    } @else {
      @for (group of cadParameterGroups; track group.cadId) {
        <section>
          <div class="mb-2">
            <div class="text-sm font-semibold text-surface-switch-900">
              {{ group.cadObject.name }}
            </div>
            @if (group.cadObject.inheritedFromName) {
              <div class="text-xs text-muted-color">
                Inherited from {{ group.cadObject.inheritedFromName }}
              </div>
            }
          </div>

          <app-parameter-editor
            [parameterSchemas]="parameterSchemas"
            [values]="group.parameters"
            [idPrefix]="'add-item-' + group.cadId + '-'"
            (parameterChanged)="onParameterEditorChange(group.cadId, $event)"
          />
        </section>
      }
    }
  </div>

  <ng-template #footer>
    <p-button label="Cancel" severity="secondary" (onClick)="closed.emit()" />
    <p-button
      [label]="cadParameterGroups.length === 0 ? 'Done' : 'Save Parameters'"
      (onClick)="save()"
    />
  </ng-template>
</p-dialog>
